import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import { Layout } from "@/components/Layout";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Films from "@/pages/Films";
import Gallery from "@/pages/Gallery";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <p className="text-[10px] tracking-[0.42em] uppercase text-ink-taupe">404</p>
        <h1 className="mt-6 font-display text-4xl text-ink-ivory">The page is absent from the archive.</h1>
        <p className="mt-4 text-sm text-ink-ivory/60">Return to the index — it is, after all, where most stories begin.</p>
        <a href="/" className="mt-10 inline-block luxe-btn">Return home</a>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/films" element={<Films />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#251F1E",
            color: "#F7F4F0",
            border: "1px solid rgba(247,244,240,0.1)",
            fontFamily: "Manrope, sans-serif",
            letterSpacing: "0.04em",
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
